import { NotFoundError } from './../common/not-found-error';
import { AppError } from './../common/app-error';
import { GeneralService } from './../services/general.service';
import { DataService } from './../services/data.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare let google: any;
declare let grecaptcha: any;

declare let $: any;

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

    constructor(private commonScriptComponent: CommonScriptComponent,
                private dataService: DataService, 
                private generalService: GeneralService,
                private router:Router) { }

    contactForm = new FormGroup({
        firstName: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
        lastName: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
        email: new FormControl('', [Validators.required, Validators.email]),
        phone: new FormControl('', [Validators.required, Validators.pattern('[0-9]*'),Validators.minLength(6)]),
        company: new FormControl('', Validators.required),
        country: new FormControl('', Validators.required),
        message: new FormControl('', [Validators.required, Validators.minLength(20)]),
        captcha: new FormControl('')
    });

    get firstName() {
        return this.contactForm.get('firstName');
    }
    get lastName() {
        return this.contactForm.get('lastName');
    }
    get email() {
        return this.contactForm.get('email');
    }
    get phone() {
        return this.contactForm.get('phone');
    }
    get company() {
        return this.contactForm.get('company');
    }
    get country() {
        return this.contactForm.get('country');
    }
    get message() {
        return this.contactForm.get('message');
    }
    // get captcha() {
    //     return this.contactForm.get('captcha');
    // }
    // set captcha(val){
    //     this.captcha
    // }


    ngOnInit() {
        //load recaptcha
        this.show_captcha();

        var locations = [
            ['Veepal,<br> 1944 Silverwood Avenue,<br> Mountain View,<br> CA 94043,<br> USA', 37.4016693, -122.0934812, 2],
            ['Veepal,<br>21175 E Via De Arboles,<br> Queen Creek, Az 85142,<br> North America', 33.0941527, -111.9093427, 3],
            ['Veepal,<br>33 Watton Street,<br> Quakers Hill, NSW- 2763,<br> Australia', -33.7287012, 150.8761167, 4],
            ['Veepal,<br>903-33 Cardigan St,<br> Guelph ON N1H 3Z5,<br> Canada', 43.5492703, -80.2544329, 1],
            ['Veepal,<br>111 Harold Rd,<br> London E13 0SG,<br> UK', 51.5346173, 0.0283564, 6],
            ['Veepal,<br>Villa 61,<br> Street 14, Meadows 9,<br> Dubai, UAE', 25.2896556, 55.3336367, 7],
            ['Veepal IT Services PVT LTD,<br>215, Westface,<br> Nr. Baghban Party Plot,<br> Thaltej, Ahmedabad - 380058 <br> Gujarat, India', 23.066424, 72.5295285, 5]
        ];

        //if user webiste open from mobile then map is draggable
        var mobile = false;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            // tasks to do if it is a Mobile Device
            mobile = true;
        }

        var map = new google.maps.Map(document.getElementById('ROADMAP'), {
            zoom: 2,
            zoomControl: false,
            scaleControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            draggable: mobile,
            mapTypeControl: false,
            streetViewControl: false,
            center: new google.maps.LatLng(51.5346173, 0.0283564),//UK
            //center: new google.maps.LatLng(23.066424, 72.5295285),//India
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        var infowindow = new google.maps.InfoWindow();

        var marker, i;



        for (i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                map: map,
                optimized: false
            });

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent(locations[i][0]);
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }

        this.commonScriptComponent.onLoad();
    }

    show_captcha() {
        //Captcha Code start
        $('#recap1').html('<div class="g-recaptcha" data-sitekey="6LcsxDQUAAAAADNrJh4MO1Pr3LiXpT6m9_tFDPu9"></div>');
        var doc = <HTMLDivElement>document.getElementById('contact-form');
        var script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        doc.appendChild(script);
        
        //Captcha Code End

    }

    submitForm() {
        //let response = grecaptcha.getResponse();
        //if (response.length === 0) {
        if($(".g-recaptcha-response").val() == ''){
            $('.recapError1').show();
            return false;
        } else {
            $('.recapError1').hide();

            $('.contact-msg').show();
            
            
            //console.log($("#g-recaptcha-response").val());
            //this.captcha();
            this.contactForm.controls['captcha'].setValue($(".g-recaptcha-response").val());
            //console.log(this.contactForm.value);
            this.dataService.post(this.generalService.SEND_EMAIL_API, this.contactForm.value)
                .subscribe(response => {
                    $('.contact-msg').hide();
                    if (response.type == 'success') {
                        //console.log(response.message);
                        //$('.alert-success').show();
                        //$('.alert-error').hide();
                        //$('.close').click();
                        this.router.navigate(['/contact-inquiry']);
                        $('.red').html('');
                      }
                      else{
                        $('.alert-success').hide();
                        $('.alert-error').show();
                        $('.alert-error').html(response.message);
                        setTimeout(() => {
                            $('.alert-error').hide();
                        }, 3000);
                        //$('.green').html('');
                      }
                        
                }, (error: AppError) => {
                    if (error instanceof NotFoundError) {
                        //redirect to the error page
                        //this.router.navigate(['/error']);
                    }
                    else {
                        //redirect to the error page
                        //this.router.navigate(['/error']);
                    }
                });
        }

        return false;
    }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/contact-us/contact-us.component.ts